import React, { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from '../../../libs/yup/yup';
import Swal from 'sweetalert2';
import { Controller, useForm } from 'react-hook-form';
import CustomInput from '../../../components/input/CustomInput';
import { createFacility } from '../../../api/sportaloka-client';
import Uploader from '../../../components/input/Uploader';

const defaultValues = {
  name: '',
  icon: ''
};

const schema = yup.object().shape({
  name: yup.string().label('Nama fasilitas').required('${label} wajib diisi'),
  icon: yup.string().label('Ikon').required('${label} wajib diisi')
});

function AddFacilityModal({ onSubmitted }) {
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await createFacility(val.icon, val.name);
      Swal.fire({
        title: 'Berhasil!',
        text: 'Facility berhasil ditambahkan',
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      reset();
      document.getElementById('closeModal').click();
      onSubmitted();
      setLoading(false);
    } catch (error) {
      if (error.response.status === 409) {
        Swal.fire({
          title: 'Gagal!',
          text: `Facility '${val.name}' sudah ada di database`,
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      } else {
        Swal.fire({
          title: 'Gagal!',
          text: 'Periksa koneksi anda dan coba kembali.',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleModalHidden = () => {
      reset();
    };

    const modalElement = document.getElementById('addFacilityModal');
    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, [reset]);

  return (
    <div className="modal" tabIndex="-1" id="addFacilityModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h5 className="modal-title">Buat Fasilitas Baru</h5>
              <button
                id="closeModal"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <Controller
                control={control}
                name="name"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div className="mb-10">
                    <CustomInput
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      type="text"
                      label="Nama Fasilitas"
                      isError={Boolean(errors.name)}
                      isSolid={true}
                      errorMessage={Boolean(errors.name) && errors.name.message}
                    />
                  </div>
                )}
              />
              <Controller
                control={control}
                name="icon"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div className="mb-10">
                    <Uploader
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      id="addIcon"
                      path="facilities/"
                      accept="image/*"
                      type="text"
                      label="Ikon"
                      isError={Boolean(errors.icon)}
                      errorMessage={Boolean(errors.icon) && errors.icon.message}
                    />
                  </div>
                )}
              />
            </div>
            <div className="modal-footer justify-content-center">
              <button
                disabled={loading}
                type="submit"
                className="btn btn-primary bg-blue-1 rounded-1">
                <i className="fa fa-plus mr-10"></i>
                <span className="fw-500">{loading ? 'Mohon tunggu...' : 'Tambahkan'}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddFacilityModal;
